// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quizScreenContainer {
  height: 100vh;
  background-color: #ecf2f1;
}

.questionImg {
  width: 150px;
  height: 150px;
  position: absolute;
  z-index: 5;
}

.includedTitle {
  color: #003e4c;
  font-size: 46px;
  font-weight: 500;
  font-family: Oswald, sans-serif;
}

.serviceTitle {
  color: #003e4c;
  font-size: 20px;
  font-weight: 500;
  font-family: Oswald, sans-serif;
  margin-bottom: 4px;
}

.serviceDesc {
  color: #003e4c;
  font-size: 15px;
  font-weight: 400;
  font-family: Rubik, sans-serif;
  max-width: 350px;
  line-height: 1.2;
}

.dropImageStyle {
  width: 400px;
  height: 100px;
}

.draggableDrop {
  border: 3px solid #003e4c;
  border-radius: 6px;
  background-color: #fff;
  width: 410px;
}

.answerTitleIcon {
  width: 90px;
  height: 40px;
  margin-right: 1.5rem;
}

.answerTitleContainer {
  background-color: #003e4c;
  padding: 0.7rem 1rem;
}

.answerTitleText {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  font-family: Oswald, sans-serif;
}

.answerDescContainer {
  padding: 0 1rem 1rem 1rem;
  height: 210px;
}

.droppableCircle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin-top: 1rem;
  border: 3px dashed #003e4c;
}

.droppableAnswer {
  width: 79px;
  height: 79px;
  border-radius: 50%;
  margin-top: 1rem;
}

.submitButton {
  background-color: #00b1d9 !important;
  color: #fff !important;
  font-size: 30px !important;
  font-weight: 600 !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-family: 'Oswald' !important;
}

.submitButton:hover {
  background-color: #056f8a !important;
}

.evaluatorModalContainer {
  width: 50%;
  padding: 2rem 3rem;
  background-color: #fff;
  border-radius: 6px;
}

.evalDesc {
  margin: 24px 0 !important;
  color: #003e4c;
  text-align: center;
  font-family: Rubik !important;
}

.correctIncorrectIcon {
  width: 200px;
  height: 45px;
}
 /* @media (max-width:1150px) and (max-height:800px) { */
  /* .submitButton {
    font-size: 18px;
    padding: 0px 10px;
  }

  .evaluatorModalContainer {
    padding: 1rem 2rem;
    width: 240px;
  }

  .evalDesc {
    margin: 12px 0;
    font-size: 0.7rem;
  }

  .correctIncorrectIcon {
    width: 120px;
    height: 30px;
  } */
/* }  */

@media (max-width:1400.95px) {
  .submitButton {
    font-size: 16px !important;
    padding: 0px 5px !important;
  }

  .evaluatorModalContainer {
    padding: 1rem 1rem;
    width: 70%;
    /* width: 240px; */
  }

  .evalDesc {
    font-size: 12px !important;
    margin: 10px 0 !important;
    font-size: 0.7rem;
  }

  .correctIncorrectIcon {
    width: 120px;
    height: 30px;
  }
}

@media (max-width:900.95px) {
  .submitButton {
    font-size: 16px !important;
    padding: 0px 5px !important;
  }

  .evaluatorModalContainer {
    padding: 1rem 1rem;
    width: 70%;
    /* width: 240px; */
  }

  .evalDesc {
    font-size: 12px !important;
    margin: 10px 0 !important;
    font-size: 0.7rem;
  }

  .correctIncorrectIcon {
    width: 120px;
    height: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/EvaluatorModal/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;CACC,uDAAuD;EACtD;;;;;;;;;;;;;;;;;;KAkBG;AACL,OAAO;;AAEP;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF","sourcesContent":[".quizScreenContainer {\n  height: 100vh;\n  background-color: #ecf2f1;\n}\n\n.questionImg {\n  width: 150px;\n  height: 150px;\n  position: absolute;\n  z-index: 5;\n}\n\n.includedTitle {\n  color: #003e4c;\n  font-size: 46px;\n  font-weight: 500;\n  font-family: Oswald, sans-serif;\n}\n\n.serviceTitle {\n  color: #003e4c;\n  font-size: 20px;\n  font-weight: 500;\n  font-family: Oswald, sans-serif;\n  margin-bottom: 4px;\n}\n\n.serviceDesc {\n  color: #003e4c;\n  font-size: 15px;\n  font-weight: 400;\n  font-family: Rubik, sans-serif;\n  max-width: 350px;\n  line-height: 1.2;\n}\n\n.dropImageStyle {\n  width: 400px;\n  height: 100px;\n}\n\n.draggableDrop {\n  border: 3px solid #003e4c;\n  border-radius: 6px;\n  background-color: #fff;\n  width: 410px;\n}\n\n.answerTitleIcon {\n  width: 90px;\n  height: 40px;\n  margin-right: 1.5rem;\n}\n\n.answerTitleContainer {\n  background-color: #003e4c;\n  padding: 0.7rem 1rem;\n}\n\n.answerTitleText {\n  color: #fff;\n  font-size: 25px;\n  font-weight: 500;\n  font-family: Oswald, sans-serif;\n}\n\n.answerDescContainer {\n  padding: 0 1rem 1rem 1rem;\n  height: 210px;\n}\n\n.droppableCircle {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  margin-top: 1rem;\n  border: 3px dashed #003e4c;\n}\n\n.droppableAnswer {\n  width: 79px;\n  height: 79px;\n  border-radius: 50%;\n  margin-top: 1rem;\n}\n\n.submitButton {\n  background-color: #00b1d9 !important;\n  color: #fff !important;\n  font-size: 30px !important;\n  font-weight: 600 !important;\n  padding: 0px 20px !important;\n  border-radius: 5px !important;\n  font-family: 'Oswald' !important;\n}\n\n.submitButton:hover {\n  background-color: #056f8a !important;\n}\n\n.evaluatorModalContainer {\n  width: 50%;\n  padding: 2rem 3rem;\n  background-color: #fff;\n  border-radius: 6px;\n}\n\n.evalDesc {\n  margin: 24px 0 !important;\n  color: #003e4c;\n  text-align: center;\n  font-family: Rubik !important;\n}\n\n.correctIncorrectIcon {\n  width: 200px;\n  height: 45px;\n}\n /* @media (max-width:1150px) and (max-height:800px) { */\n  /* .submitButton {\n    font-size: 18px;\n    padding: 0px 10px;\n  }\n\n  .evaluatorModalContainer {\n    padding: 1rem 2rem;\n    width: 240px;\n  }\n\n  .evalDesc {\n    margin: 12px 0;\n    font-size: 0.7rem;\n  }\n\n  .correctIncorrectIcon {\n    width: 120px;\n    height: 30px;\n  } */\n/* }  */\n\n@media (max-width:1400.95px) {\n  .submitButton {\n    font-size: 16px !important;\n    padding: 0px 5px !important;\n  }\n\n  .evaluatorModalContainer {\n    padding: 1rem 1rem;\n    width: 70%;\n    /* width: 240px; */\n  }\n\n  .evalDesc {\n    font-size: 12px !important;\n    margin: 10px 0 !important;\n    font-size: 0.7rem;\n  }\n\n  .correctIncorrectIcon {\n    width: 120px;\n    height: 30px;\n  }\n}\n\n@media (max-width:900.95px) {\n  .submitButton {\n    font-size: 16px !important;\n    padding: 0px 5px !important;\n  }\n\n  .evaluatorModalContainer {\n    padding: 1rem 1rem;\n    width: 70%;\n    /* width: 240px; */\n  }\n\n  .evalDesc {\n    font-size: 12px !important;\n    margin: 10px 0 !important;\n    font-size: 0.7rem;\n  }\n\n  .correctIncorrectIcon {\n    width: 120px;\n    height: 30px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
